export enum ValidationEnum {
  VALIDATE_SMART_SEARCH,
  VALIDATE_SEARCH,
  VALIDATE_MONTH,
  VALIDATE_YEAR,
}
